import { useEffect, useCallback } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from '../../../utils/UsageTracker';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { useGetToolRecommendations } from '../queries/softwareDiscoveryHooks';
import { FullWidthHighlight } from 'academy-common-lib/components/navigation/contentNavigator/LessonNavigatorAsset';
import { HR } from 'foundations-components/transitional/components/HR';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ToolRecommendationOptionalStep = ({
  to,
  useCases
}) => {
  const {
    trackId,
    lessonId,
    contentId
  } = useParams();
  const location = useLocation();
  const toolRecommendations = useGetToolRecommendations(useCases);
  const trackOptionalRecommendationStepClick = useCallback(() => {
    UsageTracker.track('contentInteraction', {
      action: 'optional-recommendation-step-clicked',
      trackId,
      lessonId
    });
  }, [lessonId, trackId]);
  useEffect(() => {
    UsageTracker.track('contentInteraction', {
      action: 'optional-recommendation-step-rendered',
      trackId,
      lessonId
    });
  }, [lessonId, trackId]);
  if (!toolRecommendations) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      paddingInline: "500",
      children: /*#__PURE__*/_jsx(HR, {
        distance: "xs"
      })
    }), /*#__PURE__*/_jsx(UIRouterLink, {
      onClick: trackOptionalRecommendationStepClick,
      to: typeof to === 'string' ? Object.assign({}, location, {
        pathname: to
      }) : to,
      use: "unstyled",
      children: /*#__PURE__*/_jsx(FullWidthHighlight, {
        isActive: [lessonId, contentId].includes('software-discovery'),
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(Box, {
            marginBlock: "-200",
            marginInlineEnd: "-200",
            children: /*#__PURE__*/_jsx(IconHolder, {
              icon: SprocketIcon,
              size: "800"
            })
          }), /*#__PURE__*/_jsxs(Box, {
            children: [/*#__PURE__*/_jsx(Badge, {
              use: "new",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.tracks.recommendations.optionalSideNav.optionalStep"
              })
            }), /*#__PURE__*/_jsx(Text, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.omniPresent.buttonLabel"
              })
            })]
          })]
        })
      })
    })]
  });
};
export default ToolRecommendationOptionalStep;